import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { CTABand } from "../components/CTABand";
import { Reveal } from "../components/Reveal";
import { IconArrow, IconNews, IconDoc } from "../components/Icons";

const MODULES = [
  { path: "/resources/insights-news", icon: <IconNews />, title: "Insights & News", desc: "Updates, announcements, and perspectives from our team." },
  { path: "/resources/publications", icon: <IconDoc />, title: "Publications & Downloads", desc: "Reports and downloadable materials." },
  { path: "/gallery", icon: <IconNews />, title: "Gallery", desc: "Our teams at work in the field, labs, and training rooms." },
  { path: "/resources/faqs", icon: <IconDoc />, title: "FAQs", desc: "Answers to common questions about our work and how to engage us." },
];

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <PageHeader
        eyebrow="Knowledge & downloads"
        title="Resources"
        lead="Insights, publications, downloads, and answers — a growing library from the Lemur Quality team."
        crumb="Resources"
      />
      <section className="section bg-paper">
        <div className="wrap">
          <div className="hub-grid" data-testid="resources-modules">
            {MODULES.map((m, i) => (
              <Reveal key={m.path} delay={(i % 3) * 60}>
                <Link to={m.path} className="hub-card" data-testid={`resource-card-${m.path.split("/").pop()}`}>
                  <div className="hc-ic">{m.icon}</div>
                  <h3>{m.title}</h3>
                  <p>{m.desc}</p>
                  <span className="more">Open <IconArrow /></span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-mist">
        <div className="wrap">
          <Reveal className="download-card" data-testid="resources-contact-card">
            <span className="eyebrow">Work with us</span>
            <h3>Ready to strengthen your quality and compliance?</h3>
            <p>Talk to our team about quality assurance, laboratory testing, inspection, certification, and compliance consulting.</p>
            <Link to="/contact" className="btn btn-light" data-testid="resources-contact-cta">Request a Consultation</Link>
          </Reveal>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
